// Lấy IP public của thiết bị (trình duyệt tự hỏi dịch vụ bên ngoài) — dùng khi server sau proxy
// chỉ thấy 127.0.0.1. Cache 5 phút để không gọi nhiều.
let cached = '';
let ts = 0;

export async function getPublicIp() {
  if (cached && Date.now() - ts < 5 * 60 * 1000) return cached;
  const isIpv4 = (s) => /^\d{1,3}(\.\d{1,3}){3}$/.test(s || '');
  // Ưu tiên endpoint IPv4-ONLY (api4/ipv4) — server chỉ chấp nhận IPv4; nếu mạng ra IPv6 thì bị bỏ.
  const jsonUrls = ['https://api4.ipify.org?format=json', 'https://api.ipify.org?format=json'];
  for (const u of jsonUrls) {
    try {
      const r = await fetch(u, { cache: 'no-store' });
      const j = await r.json();
      if (j && isIpv4(j.ip)) { cached = j.ip; ts = Date.now(); return j.ip; }
    } catch (e) { /* thử url khác */ }
  }
  for (const u of ['https://ipv4.icanhazip.com', 'https://icanhazip.com']) {
    try {
      const r = await fetch(u, { cache: 'no-store' });
      const t = (await r.text()).trim();
      if (isIpv4(t)) { cached = t; ts = Date.now(); return t; }
    } catch (e) { /* bỏ qua */ }
  }
  return '';
}
